import { useRef } from "react";
import MainLayout from "../layout/main-layout";
import MetaTags from "../utils/meta-tags";
import TechnologiesHeadSection from "../Components/technologies/technologies-head-section";
import TechnologiesStack from "../Components/technologies/technologies-stack";
import TechnologiesShowcase from "../Components/technologies/technologies-showcase";
import TechnologiesProcess from "../Components/technologies/technologies-process";
import WhyChooseTechnologies from "../Components/technologies/why-choose-technologies";
import TechnologiesContact from "../Components/technologies/technologies-contact";

function Technologies() {
    const contactRef = useRef<HTMLDivElement>(null);

    const handleScrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div>
            <MetaTags
                title="Technologies We Use | Modern Full-Stack | SoftCoding Solutions"
                description="Explore the technologies we specialize in — React, Node.js, Ruby on Rails, Python, Flutter, AI/ML, Cloud and more. Modern stacks built for scale."
                canonical="https://softcodingsolutions.com/technologies"
                og={{
                    title: "Our Technology Stack | SoftCoding Solutions",
                    description:
                        "40+ technologies mastered across frontend, backend, mobile, cloud and AI — the modern stack that powers great products.",
                    url: "https://softcodingsolutions.com/technologies",
                    type: "website",
                    site_name: "SoftCoding Solutions",
                    image:
                        "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
                    imageWidth: "1200",
                    imageHeight: "630",
                }}
            />
            <MainLayout>
                <TechnologiesHeadSection onScroll={handleScrollToContact} />
                <TechnologiesStack />
                <TechnologiesShowcase />
                <TechnologiesProcess />
                <WhyChooseTechnologies />
                <TechnologiesContact contactRef={contactRef} />
            </MainLayout>
        </div>
    );
}

export default Technologies;
